/**********************************************************/
/*    function tabs ( exemple consultutation)            */
/*********************************************************/

function tabs() {
  $('.onglets .onglet').click(
    function() {
      var tabs_id = $(this).attr('data-target');
      $('.onglets .onglet').removeClass('current');
      $('.contenu_onglet').removeClass('current');

      $(this).addClass('current');
      $(tabs_id).addClass('current');

      if (tabs_id == "#contenu_onglet_first") {
        $('#zone-icons1').addClass('current');
        $('#zone-icons2').removeClass('current');
      } else if (tabs_id == "#contenu_onglet_second") {
        $('#zone-icons2').addClass('current');
        $('#zone-icons1').removeClass('current');
      } else if (tabs_id == "#contenu_onglet_third") {
        $('#zone-icons2').removeClass('current');
        $('#zone-icons1').removeClass('current');
      }
      // var section = document.querySelectorAll(".contenu_onglet.current .block-slide-right");
      // scrollspy(document.querySelector(tabs_id));
      // activeCurrentBlock();
    }
  );

  var activeCurrentBlock = function() {
    if ($('.contenu_onglet.current .block-slide-right.current').get(0) === undefined) {
      $('.contenu_onglet.current .block-slide-right:first-child').addClass('current');
    }
  };

  activeCurrentBlock();

  var scrollspy = function(selector) {
    selector.onscroll = function() {
      var container = document.querySelector(".contenu_onglet.current"),
        scrollPosition = container.scrollTop;
      var section = document.querySelectorAll(".contenu_onglet.current .block-slide-right");
      var sections = [];
      var i = 0;
      Array.prototype.forEach.call(
        section,
        function(el) {
          sections[el.id] = $('.contenu_onglet.current').scrollTop() + $('#' + el.id).offset().top - 160;
        }
      );

      for (i in sections) {
        if (sections[i] <= scrollPosition) {
          $('.contenu_onglet.current .zone-icons span.active').removeClass('active');
          $('.zone-icons a[href^="#' + i + '"]').parent().addClass('active');
          $('.contenu_onglet.current .block-slide-right.current').not('#' + i).removeClass('current');
          if (!$('#' + i).hasClass('current')) {
            $('#' + i).addClass('current');
          }
        }
      }
    };
  };

  //scrollspy();
}
